// src/cert/gdpr.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const GDPR = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>GDPR अनुपालन</h1>
                <p>सामान्य डेटा संरक्षण नियमन (General Data Protection Regulation)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>GDPR म्हणजे काय?</h2>
                    <p>
                        The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.

                        Organizations that control or process personal data from the European Union, even if operating from or outside the European Union, must comply with Global Data Protection Regulation (GDPR) legislation that protects the fundamental right to privacy of EU citizens. This law is not just limited to companies providing financial services. This law standardized the practices of lawfully collecting, processing, and storing EU citizens and residents personal data, and is applicable even to companies that have business arrangements with businesses that work with such sensitive data. A personal data breach can cost companies dearly. Cloud4Cs experts are here to guide your organization to comprehensive General Data Protection Regulation (GDPR) compliance in the most efficient way possible while enhancing your cybersecurity. Speak to our team today to discover why global industry leaders trust Cloud4C for GDPR compliance, personal data protection, process personal data, data access management, information security, and more.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>EU मध्ये व्यवसाय करणे कायदेशीर राहते</li>
                        <li>€20 मिलियन किंवा 4% वार्षिक उलाढालीचा दंड टाळता येतो</li>
                        <li>ग्राहकांचा डेटा संरक्षण विश्वास वाढतो</li>
                        <li>डेटा प्रक्रिया, संमती, हक्क (Right to be Forgotten) व्यवस्थित होतात</li>
                        <li>जागतिक स्तरावर डेटा गोपनीयता मानक उंचावतो</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>GDPR अनुपालनासाठी अर्ज करा</h2>
                    <ApplyForm certification="GDPR" />
                </section>
            </div>
        </div>
    );
};

export default GDPR;